function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _require = require("./utils"),
    Emitter = _require.Emitter;

function findNearestNode(i, nodes) {
  if (!nodes.length) return;

  var _matchNodes$map = matchNodes(nodes, i).map(function (r) {
    return r.node;
  }),
      _matchNodes$map2 = _slicedToArray(_matchNodes$map, 2),
      left = _matchNodes$map2[0],
      right = _matchNodes$map2[1];

  if (left == right) {
    return left;
  }

  if (i - left.offset - left.viewValue.length <= right.offset - i) {
    return left;
  }

  return right;
}

function matchNodes(nodes, start) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : start;
  var node, left, right;

  var _iterator = _createForOfIteratorHelper(nodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      node = _step.value;

      if (node.offset <= start) {
        left = {
          node: node,
          pos: start - node.offset
        };
      }

      if (node.offset + node.viewValue.length >= end && !right) {
        right = {
          node: node,
          pos: end - node.offset
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!right) {
    var last = nodes[nodes.length - 1];
    right = {
      node: last,
      pos: last.viewValue.length
    };
  }

  if (!left) {
    var first = nodes[0];
    left = {
      node: first,
      pos: 0
    };
  }

  if (left.pos > left.node.viewValue.length) {
    left.pos = left.node.viewValue.length;
  }

  return [left, right];
}

var Selection = /*#__PURE__*/function () {
  function Selection(element, nodes) {
    _classCallCheck(this, Selection);

    this.el = element;
    this.nodes = nodes;
    this.range = {
      node: findNearestNode(0, this.nodes),
      start: 0,
      end: "end"
    };
  }

  _createClass(Selection, [{
    key: "selectNearestNode",
    value: function selectNearestNode() {
      var range = this.el.getSelection();
      if (!range) return;
      this.select({
        node: findNearestNode(range.start, this.nodes),
        start: 0,
        end: "end"
      });
    }
  }, {
    key: "select",
    value: function select(range) {
      range = Object.assign(this.range, range);

      if (range.node) {
        this.el.setSelection(range.node.offset + range.start, range.node.offset + (range.end == "end" ? range.node.viewValue.length : range.end));
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.range.node) {
        return this.range.node.nextEdit;
      }
    }
  }, {
    key: "hasPrev",
    value: function hasPrev() {
      if (this.range.node) {
        return this.range.node.prevEdit;
      }
    }
  }, {
    key: "selectNext",
    value: function selectNext() {
      var node = this.hasNext(),
          range = {
        start: 0,
        end: "end"
      };

      if (node) {
        range.node = node;
      }

      this.select(range);
    }
  }, {
    key: "selectPrev",
    value: function selectPrev() {
      var node = this.hasPrev(),
          range = {
        start: 0,
        end: "end"
      };

      if (node) {
        range.node = node;
      }

      this.select(range);
    }
  }, {
    key: "get",
    value: function get() {
      if (!this.nodes.length) return;
      var range = this.el.getSelection();
      if (!range) return;

      var _matchNodes = matchNodes(this.nodes, range.start, range.end),
          _matchNodes2 = _slicedToArray(_matchNodes, 2),
          left = _matchNodes2[0],
          right = _matchNodes2[1];

      if (left.node == right.node) {
        this.range = {
          node: left.node,
          start: left.pos,
          end: right.pos
        };
      }
    }
  }, {
    key: "atNodeEnd",
    value: function atNodeEnd() {
      if (!this.range.node) return;
      this.get();
      var len = this.range.node.viewValue.length,
          max = this.range.node.token.maxLength,
          start = this.range.start == "end" ? len : this.range.start,
          end = this.range.end == "end" ? len : this.range.end;
      return start == end && start == (max != null ? max : len) || !len;
    }
  }, {
    key: "atNodeStart",
    value: function atNodeStart() {
      if (!this.range.node) return;
      this.get();
      var len = this.range.node.viewValue.length,
          start = this.range.start == "end" ? len : this.range.start,
          end = this.range.end == "end" ? len : this.range.end;
      return start == end && start == 0;
    }
  }]);

  return Selection;
}();

var InputMask = /*#__PURE__*/function (_Emitter) {
  _inherits(InputMask, _Emitter);

  var _super = _createSuper(InputMask);

  function InputMask() {
    var _this;

    _classCallCheck(this, InputMask);

    _this = _super.call(this);

    _this._constructor.apply(_assertThisInitialized(_this), arguments);

    _this.initialize();

    return _this;
  }

  _createClass(InputMask, [{
    key: "_constructor",
    value: function _constructor(element, textParser) {
      var separators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      this.el = element;
      this.tp = textParser;
      this.separators = separators;
      this.sel = new Selection(element, textParser.getNodes().filter(function (n) {
        return n.token.type != "static";
      }));
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.el.on("mousedown", function () {
        _this2.mousedown = true;
      });
      this.el.on("focus", function () {
        if (_this2.mousedown) return; // wait mouseup then decide range

        setTimeout(function () {
          _this2.sel.select({
            start: 0,
            end: "end"
          });
        });
      });
      this.el.on("click", function () {
        _this2.mousedown = false;

        _this2.sel.selectNearestNode();
      });
      this.el.on("input", function () {
        _this2.digest(null, _this2.el.val());
      });
      this.el.on("keydown", function (e) {
        if (e.altKey || e.ctrlKey) {
          return;
        }

        if (e.keyCode == 37 || e.keyCode == 9 && e.shiftKey && _this2.sel.hasPrev()) {
          // Left, Shift + Tab
          e.preventDefault();

          _this2.tryFixingError();

          _this2.sel.selectPrev();
        } else if (e.keyCode == 39 || e.keyCode == 9 && !e.shiftKey && _this2.sel.hasNext()) {
          // Right, Tab
          e.preventDefault();

          _this2.tryFixingError();

          _this2.sel.selectNext();
        } else if (e.keyCode == 38) {
          // Up
          e.preventDefault();

          _this2.sel.selectNearestNode();

          if (_this2.sel.range.node) {
            // this.err = null;
            _this2.sel.range.node.add(1);
          }

          _this2.val(_this2.tp.getText());

          _this2.sel.select({
            start: 0,
            end: "end"
          });
        } else if (e.keyCode == 40) {
          // Down
          e.preventDefault();

          _this2.sel.selectNearestNode();

          if (_this2.sel.range.node) {
            // this.err = null;
            _this2.sel.range.node.add(-1);
          }

          _this2.val(_this2.tp.getText());

          _this2.sel.select({
            start: 0,
            end: "end"
          });
        } else if (e.keyCode == 36 || e.keyCode == 35) {
          // Home or End
          setTimeout(function () {
            return _this2.sel.selectNearestNode();
          });
        } else if (e.keyCode == 46) {
          // Del
          if (_this2.sel.atNodeEnd()) {
            e.preventDefault();

            _this2.tryFixingError();

            _this2.sel.selectNext();
          }
        } else if (e.keyCode == 8) {
          // Backspace
          if (_this2.sel.atNodeStart()) {
            e.preventDefault();

            _this2.tryFixingError();

            _this2.sel.selectPrev();
          }
        }
      });
      this.el.on("keypress", function (e) {
        var charCode = e.charCode == null ? e.keyCode : e.charCode,
            key = String.fromCharCode(charCode),
            separators = _this2.separators,
            node = _this2.sel.range.node; // check for separator only when there is a next node which is static string

        if (node && node.next && node.next.token.type == "static") {
          separators += node.next.viewValue[0];
        }

        if (separators.includes(key)) {
          e.preventDefault();

          _this2.tryFixingError();

          _this2.sel.selectNext();

          return;
        }

        setTimeout(function () {
          if (_this2.sel.atNodeEnd() && _this2.sel.range.node.viewValue) {
            _this2.tryFixingError();

            _this2.sel.selectNext();
          }
        });
      });
      this.el.on("blur", function () {
        setTimeout(function () {
          _this2.tryFixingError();
        });
      });
      this.tp.on("change", function () {
        if (!_this2.err && !_this2.inDigest) {
          _this2.val(_this2.tp.getText());

          _this2.sel.select();
        }
      }); // Init value

      var text = this.el.val();

      if (text) {
        this.digest(null, text, true);
      } else {
        this.val(this.tp.getText());
      }
    }
  }, {
    key: "errorViewLength",
    value: function errorViewLength() {
      if (this.err && this.err.viewValue != null) {
        return this.err.viewValue.length;
      }

      return undefined;
    }
  }, {
    key: "val",
    value: function val(text) {
      if (this.el.val() != text) {
        this.el.val(text);
      }

      this.err = null;
    }
  }, {
    key: "tryFixingError",
    value: function tryFixingError() {
      if (!this.err) return;

      if (this.err.properValue) {
        this.digest(this.err.node, this.err.properValue, true);
      } else if (this.err.node) {
        this.err.node.unset();
        this.digest(null, this.tp.getText());
      }
    }
  }, {
    key: "digest",
    value: function digest(node, text, fixErr) {
      var digest = 10,
          range;
      this.inDigest = true;

      while (digest--) {
        this.err = null;

        try {
          if (node) {
            node.parse(text);
          } else {
            this.tp.parse(text);
          }
        } catch (err) {
          this.emit("digest", err);
          this.sel.get();

          if (err.code == "NOT_INIT") {
            break;
          }

          this.err = err;

          if (!fixErr && (err.code == "NUMBER_TOOSHORT" || err.code == "NUMBER_TOOSMALL" || err.code == "NUMBER_MISMATCH" || err.code == "SELECT_MISMATCH" || err.code == "LEADING_ZERO")) {
            break;
          }

          if (err.code == "SELECT_INCOMPLETE") {
            node = err.node;
            text = err.selected;
            range = {
              end: "end"
            };
            continue;
          }

          if (err.properValue != null) {
            node = err.node;
            text = err.properValue;
          } else if (err.properText != null) {
            node = null;
            text = err.properText;
          } else {
            if (err.code == "EMPTY") {
              this.tp.unset();
            }

            if (err.node) {
              err.node.unset();
            }

            node = null;
            text = this.tp.getText();
            range = {
              start: 0,
              end: "end"
            };
          }

          continue;
        }

        break;
      }

      if (!this.err) {
        this.val(this.tp.getText());

        if (digest < 9) {
          this.sel.select(range);
        }
      }

      this.inDigest = false;

      if (digest < 0) {
        throw new Error("InputMask.digest crashed! Infinite loop on ".concat(text));
      }
    }
  }]);

  return InputMask;
}(Emitter);

module.exports = {
  InputMask: InputMask
};